// extracted by mini-css-extract-plugin
export default {"leftside":"MenuPage_leftside__i8vW7","rightside":"MenuPage_rightside__CDFmW","framesChoice":"MenuPage_framesChoice__dxL-+","buttonsArea":"MenuPage_buttonsArea__icNlg"};